module.exports = __webpack_public_path__ + "img/menu02.16cde759.svg";